module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-table-container"
  }, [_c('table', {
    staticClass: "user-table"
  }, [_c('thead', [_c('tr', [_c('thUser', {
    attrs: {
      "rowspan": "3",
      "sort-prop": "name",
      "title": _vm.$t('vue2.assign_users_hours.name'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "working-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), (_vm.isPoolsDeactivated) ? _c('th', {
    staticClass: "rest-hours",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Rest")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "teaching-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.teaching')))])]), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
    staticClass: "task-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.tasks')))])]) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
    staticClass: "prep-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.assign_users_hours.preparation')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? _c('th', {
    staticClass: "prep-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_vm._v("\n        Lokalpulje\n      ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "absence-hours",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.absence')))]), _vm._v(" "), _c('th', {
    staticClass: "sub-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.substitute_hours')))]), _vm._v(" "), (_vm.isSFOActive) ? _c('th', {
    staticClass: "club-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.club')))])]) : _vm._e()], 1), _vm._v(" "), _c('tr', [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "assigned_total_hours",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_total_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "diff_total_hours",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPoolsDeactivated) ? _c('thUser', {
    attrs: {
      "sort-prop": "rest_hours",
      "title": "Rest",
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "assigned_teaching_hours",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_teaching_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "diff_teaching_hours",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "assigned_additional_task_hours",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_additional_task_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "diff_additional_task_hours",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "assigned_preparation_hours",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_preparation_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "diff_preparation_hours",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "assigned_pool_hours",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_pool_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "diff_pool_hours",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_absence_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "substitute_pool_hours",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_substitute_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "diff_substitute_hours",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "assigned_club_hours",
      "title": _vm.$t('vue2.assign_users_hours.assigned'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e(), _vm._v(" "), _c('thUser', {
    attrs: {
      "sort-prop": "actual_club_hours",
      "title": _vm.$t('vue2.assign_users_hours.scheduled'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('thUser', {
    attrs: {
      "sort-prop": "diff_club_hours",
      "title": _vm.$t('vue2.assign_users_hours.diff'),
      "activeSortKey": _vm.sortKey
    },
    on: {
      "sortby": _vm.sortBy
    }
  }) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "user-table__body"
  }, _vm._l((_vm.filteredData), function(user) {
    return _c('trUser', {
      key: user.id,
      attrs: {
        "theUserCanManageAssignedHours": _vm.theUserCanManageAssignedHours,
        "schoolid": _vm.schoolid,
        "user": user,
        "isSFOActive": _vm.isSFOActive,
        "isLocalPoolActivated": _vm.isLocalPoolActivated,
        "isSchoolYearWithNewEmploymentDeal": _vm.isSchoolYearWithNewEmploymentDeal,
        "activeSchoolYear": _vm.activeSchoolYear,
        "isDatesPristine": _vm.isDatesPristine,
        "numberOfWorkDays": _vm.numberOfWorkDays,
        "numberOfWorkDaysInPeriod": _vm.numberOfWorkDaysInPeriod,
        "locale": _vm.locale,
        "viewSettings": _vm.viewSettings,
        "isPoolsDeactivated": _vm.isPoolsDeactivated,
        "prepFactor": _vm.prepFactor
      },
      on: {
        "openEdit": _vm.setOpenEdit,
        "setTheUserToShowTasks": _vm.setTheUserToShowTasks,
        "setActiveUser": _vm.setActiveUser
      }
    })
  }), 1)]), _vm._v(" "), (_vm.theEditNumberUserId) ? _c('div', {
    ref: "popper_child",
    staticClass: "popper_child"
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [(_vm.isDropdownPopperDone) ? _c('div', {
    staticClass: "number__input-opened"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.theEditNumberNumber),
      expression: "theEditNumberNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeEditing),
      expression: "closeEditing"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.theEditNumberNumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doneEditing.apply(null, arguments)
      },
      "change": function($event) {
        _vm.theEditNumberNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--primary",
    class: {
      'bttn--small--loading': _vm.isUpdatingNumber
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doneEditing.apply(null, arguments)
      }
    }
  }, [(!_vm.isUpdatingNumber) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12ea7e91!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursAllUsers.vue
// module id = 1517
// module chunks = 1